module.exports = __webpack_public_path__ + "img/partners_short.961a5b14.png";